import { render, staticRenderFns } from "./TemplateTwoColumns.vue?vue&type=template&id=74266d7f&scoped=true"
import script from "./TemplateTwoColumns.vue?vue&type=script&lang=js"
export * from "./TemplateTwoColumns.vue?vue&type=script&lang=js"
import style0 from "./TemplateTwoColumns.vue?vue&type=style&index=0&id=74266d7f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74266d7f",
  null
  
)

export default component.exports